module.exports = {
  context: {
    class: 'left',
    buttons: [
      {
        text: 'Learn More',
        url: 'http://www.google.com/',
        class: 'primary'
      },
      {
        text: 'Learn More',
        url: 'http://www.google.com/',
        class: 'secondary'
      },
      {
        text: 'Learn More',
        url: 'http://www.google.com/',
        class: 'info'
      },
      {
        text: 'Learn More',
        url: 'https://google.com',
        class: 'cta'
      }
    ]
  }
}
